<template>
  <div class="flex flex-column gap-2">
    <label class="block">Pull episodes in playlist:</label>
    <div class="flex gap-3 flex-wrap">
      <div
        class="pull-mode-option flex align-items-center gap-2 px-3 py-2 border-round-3xl cursor-pointer"
        :class="{ 'pull-mode-option-active': modelValue === false }"
        @click="$emit('update:modelValue', false)"
      >
        <RadioButton
          inputId="pullModePerShowConfig"
          :modelValue="modelValue"
          :value="false"
          name="episodePullMode"
          @update:modelValue="$emit('update:modelValue', $event)"
        />
        <label for="pullModePerShowConfig" class="cursor-pointer"
          >Based on each show's configuration</label
        >
      </div>
      <div
        class="pull-mode-option flex align-items-center gap-2 px-3 py-2 border-round-3xl cursor-pointer"
        :class="{ 'pull-mode-option-active': modelValue === true }"
        @click="$emit('update:modelValue', true)"
      >
        <RadioButton
          inputId="pullModeFullCatalog"
          :modelValue="modelValue"
          :value="true"
          name="episodePullMode"
          @update:modelValue="$emit('update:modelValue', $event)"
        />
        <label for="pullModeFullCatalog" class="cursor-pointer"
          >Full episode catalog</label
        >
      </div>
    </div>
    <Message severity="info" :closable="false">{{
      modelValue ? MODE_DESCRIPTIONS.full : MODE_DESCRIPTIONS.perShow
    }}</Message>
  </div>
</template>

<script setup>
import RadioButton from "primevue/radiobutton";
import Message from "primevue/message";

defineProps({
  modelValue: {
    type: Boolean,
    default: false,
  },
});
defineEmits(["update:modelValue"]);

const MODE_DESCRIPTIONS = {
  perShow: `Episodes are pulled automatically from every selected show, based on that show's own episode settings (how far back to look, how many episodes to include).`,
  full: `All of each selected show's episodes are included, ignoring its normal episode limits. Only use this when the publisher will pick which episodes to show.`,
};
</script>

<style scoped>
.pull-mode-option {
  border: 1px solid var(--surface-border);
  transition: all 0.15s ease;
}

.pull-mode-option:hover {
  border-color: var(--primary-color);
}

.pull-mode-option-active {
  border-color: var(--primary-color);
  background: rgba(99, 102, 241, 0.08);
}
</style>
